
import Avatar from "~/components/ui/Avatar.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Avatar,
  },
  props: {
    profiles: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters({ discreetMode: "getDiscreetStatus" }),
  },
};
